import React from 'react';
import {Link} from 'gatsby';
import IconArrowHero from './IconArrowHero';
import {connectToStore} from './Provider';
import createTaxonomyLink from '../utils/createTaxonomyLink';

const HomeHero = ({
	mobileBackgroundImage,
	backgroundImage,
	title,
	subtitle,
	categoryLinks = [],
	cta,
	openVideoModal,
}) => {
	let ctaButton;

	if (cta._type === 'videoModalLink') {
		ctaButton = (
			<button
				title={cta.title}
				onClick={() => openVideoModal(cta.videoId)}
				name="video"
				className="button--video-white">
				{cta.title}
			</button>
		);
	} else if (cta._type === 'link') {
		if (cta.url[0] === '/') {
			ctaButton = (
				<Link
					title={cta.title}
					to={cta.url}
					className="button--primary-white">
					{cta.title}
				</Link>
			);
		} else {
			ctaButton = (
				<a
					title={cta.title}
					href={cta.url}
					className="button--primary-white">
					{cta.title}
				</a>
			);
		}
	} else if (cta._type === 'taxonomyLink') {
		ctaButton = (
			<Link
				title={cta.title}
				to={createTaxonomyLink(cta.taxonomies)}
				className="button--primary-white">
				{cta.title}
			</Link>
		);
	}

	const bgImage = (
		<div className="image--cover hero__bg--home">
			<picture>
				<source
					srcSet={`${backgroundImage}?w=2000&auto=format`}
					media="(min-width: 1400px)"
				/>
				<source
					srcSet={`${backgroundImage}?w=1600&auto=format`}
					media="(min-width: 600px)"
				/>
				<img
					alt={title}
					src={`${mobileBackgroundImage}?w=800&auto=format`}
				/>
			</picture>
		</div>
	);

	const categoryColumns = categoryLinks.map(link => (
		<div
			key={link._key}
			className="col c6--sm">
			<Link
				title={link.title}
				to={link.url}
				className="hero__col--home db pt4 pl2 pr2 pb4 pb5--md pl8--xl pr8--xl tc link--hover--target">
				<img
					alt={link.title}
					src={link.icon}
					className="db m--auto mb2"
				/>
				<span className="db sans--small uppercase fw--600 mb1">
					{link.title}
				</span>
				<span className="db sans--small fw--500 color--gray-border mb2">
					{link.description}
				</span>
				<span className="db">
					<span className="db m--auto button--hero">
						<IconArrowHero />
					</span>
				</span>
			</Link>
		</div>
	));
	
	return (
		<div className="pr bg--gray-text color--white">
			{bgImage}
			<div className="push-up">
				<div className="grid-container contained">
					<div className="pt10 pb10">
						<div className="pt2 pb2 pt6--md pb0--md">
							<div className="row align--center">
								<div className="col c8--md c6--xl">
									<div className="tc">
										<h2 className="uppercase fw--600 mb2">
											{subtitle}
										</h2>
										<h1 className="domaine--large mb4 text-shadow ml8--sm mr8--sm ml0--md mr0--md">
											{title}
										</h1>
										{ctaButton}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row align--center">
						<div className="col c10--lg">
							<div className="hero__footer--home pr pt10--sm">
								<div className="hero__footer--home--inner">
									<div className="row">
										{categoryColumns}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	);
};


const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(HomeHero);